// extracted by mini-css-extract-plugin
module.exports = {"bpSmallOnly":"(max-width: 799px)","bpMediumUp":"(min-width: 800px)","bpLargeUp":"(min-width: 900px)","bpXLargeUp":"(min-width: 1200px)","bpXXLargeUp":"(min-width: 1800px)"};